/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyResponseData = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        submissionId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        answerText: {
    type: 'string',
    isNullable: true,
},
        answerBool: {
    type: 'boolean',
    isNullable: true,
},
        answerOptionId: {
    type: 'number',
    isNullable: true,
},
        answerOptionIds: {
    type: 'array',
    contains: {
    type: 'number',
},
    isNullable: true,
},
        answerRating: {
    type: 'number',
    isNullable: true,
},
        skipQuestion: {
    type: 'boolean',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};